module.exports = __webpack_public_path__ + "img/vip@2x.188ac07f.png";